import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class CookieBanner extends UcoastEl {
    static htmlSelector = 'cookie-banner'

    acceptButton: HTMLButtonElement
    declineButton: HTMLButtonElement
    clarityProjectId: string = 'YOUR_CLARITY_PROJECT_ID'

    constructor() {
        super()

        this.acceptButton = q.rs('#acceptCookies', this)
        this.declineButton = q.rs('#declineCookies', this)
        this.clarityProjectId = this.dataset.id || ''

        if(!this.clarityProjectId) return

        const consent = localStorage.getItem('clarity_consent')

        if (consent === 'granted') {
            this.sendClarityConsent(true)
            this.loadClarity()
            this.hideBanner()
        } else if (consent === 'declined') {
            this.sendClarityConsent(false)
            this.hideBanner()
        } else {
            this.showBanner()
        }

        this.acceptButton.addEventListener('click', (e) => {
            e.preventDefault()
            localStorage.setItem('clarity_consent', 'granted')
            this.sendClarityConsent(true)
            this.loadClarity()
            this.hideBanner()
        })

        this.declineButton.addEventListener('click', (e) => {
            e.preventDefault()
            localStorage.setItem('clarity_consent', 'declined')
            this.sendClarityConsent(false)
            this.hideBanner()
        })
    }

    private loadClarity() {
        ;((c,l,a,r,i,t,y) => {
            c[a] = c[a] || function() { (c[a].q = c[a].q || []).push(arguments) }
            t = l.createElement(r)
            t.async = true
            t.src = 'https://www.clarity.ms/tag/' + i
            y = l.getElementsByTagName(r)[0]
            y.parentNode?.insertBefore(t, y)
        })(window, document, 'clarity', 'script', this.clarityProjectId)
    }

    private sendClarityConsent(granted: boolean) {
        window.clarity = window.clarity || function() {
            (window.clarity.q = window.clarity.q || []).push(arguments)
        }
        if (window.clarity) {
            clarity('consent', granted ? 'granted' : 'denied')
        }
    }

    private showBanner() {
        this.classList.remove('hidden')
    }

    private hideBanner() {
        this.classList.add('hidden')
    }
}